var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg67Nascar = function Svg67Nascar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM5.62 15.94L7.8 8.06H8.7L6.53 15.94H5.62ZM7.11 15.94L9.3 8.06H10.2L8.02 15.94H7.11ZM8.83 15.94L11.03 8.06H12.48L10.3 15.94H8.83ZM10.88 15.94L13.08 8.06H14.52L12.35 15.94H10.88ZM16.2 15.93H13.18L15.37 8.06H18.38L16.2 15.93Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg67Nascar, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPHBhdGgNCiAgICBkPSJNMTIgM0M3LjAzIDMgMyA3LjAzIDMgMTJDMyAxNi45NyA3LjAzIDIxIDEyIDIxQzE2Ljk3IDIxIDIxIDE2Ljk3IDIxIDEyQzIxIDcuMDMgMTYuOTcgMyAxMiAzWk01LjYyIDE1Ljk0TDcuOCA4LjA2SDguN0w2LjUzIDE1Ljk0SDUuNjJaTTcuMTEgMTUuOTRMOS4zIDguMDZIMTAuMkw4LjAyIDE1Ljk0SDcuMTFaTTguODMgMTUuOTRMMTEuMDMgOC4wNkgxMi40OEwxMC4zIDE1Ljk0SDguODNaTTEwLjg4IDE1Ljk0TDEzLjA4IDguMDZIMTQuNTJMMTIuMzUgMTUuOTRIMTAuODhaTTE2LjIgMTUuOTNIMTMuMThMMTUuMzcgOC4wNkgxOC4zOEwxNi4yIDE1LjkzWiIgLz4NCjwvc3ZnPg==";
export { ForwardRef as ReactComponent };